const BlogPostDetail = ({ post }) => {
  if (!post) {
    return (
      <div className="p-8 text-center">
        <p className="text-lg text-gray-600">Post not found.</p>
      </div>
    );
  }

  return (
    <article>
      {/* Header */}
      <div className="mb-8 pb-8 border-b border-gray-200">
        {post.category && (
          <div className="mb-4">
            <span className="inline-block bg-blue-100 text-blue-800 text-xs font-semibold px-3 py-1 rounded-full">
              {post.category}
            </span>
          </div>
        )}
        <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4 leading-tight">
          {post.title}
        </h1>
        <div className="flex items-center gap-4 text-gray-600 flex-wrap">
          <span className="text-sm font-medium">
            {new Date(post.date).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
          </span>
          {post.tags && (
            <div className="flex gap-2 flex-wrap">
              {post.tags.split(',').map((tag, i) => (
                <span key={i} className="text-xs bg-gray-100 px-2 py-1 rounded font-medium text-gray-700">
                  #{tag.trim()}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Featured Image */}
      {post.featuredImage && (
        <div className="mb-10 -mx-8 sm:-mx-12">
          <img
            src={post.featuredImage}
            alt={post.title}
            className="w-full h-96 object-cover rounded-lg"
            onError={(e) => { e.target.style.display = 'none'; }}
          />
        </div>
      )}

      {/* Content - Main Article Text */}
      <div className="mb-12 text-gray-800">
        <style>{`
          .article-content h2 {
            font-size: 1.875rem;
            font-weight: 700;
            margin-top: 2rem;
            margin-bottom: 1rem;
            color: #1f2937;
          }
          .article-content h3 {
            font-size: 1.5rem;
            font-weight: 600;
            margin-top: 1.5rem;
            margin-bottom: 0.75rem;
            color: #374151;
          }
          .article-content p {
            font-size: 1.0625rem;
            line-height: 1.8;
            color: #4b5563;
            margin-bottom: 1.25rem;
          }
          .article-content ul, .article-content ol {
            margin: 1.5rem 0;
            padding-left: 2rem;
          }
          .article-content li {
            font-size: 1.0625rem;
            line-height: 1.8;
            margin-bottom: 0.5rem;
            color: #4b5563;
          }
          .article-content a {
            color: #2563eb;
            text-decoration: underline;
          }
          .article-content a:hover {
            color: #1d4ed8;
          }
        `}</style>
        
        <div className="article-content">
          {post.content && (
            <div dangerouslySetInnerHTML={{ __html: post.content }} />
          )}
          {!post.content && post.body && (
            <div dangerouslySetInnerHTML={{ __html: post.body }} />
          )}
        </div>
      </div>

      {/* Meta Info / Summary */}
      {(post.metaDesc || post.keywords) && (
        <div className="mt-12 pt-8 border-t border-gray-200">
          <div className="bg-blue-50 rounded-lg p-6 lg:p-8 border border-blue-200">
            {post.metaDesc && (
              <div className="mb-6">
                <h3 className="text-sm font-semibold text-blue-900 mb-2 uppercase tracking-wide">Article Summary</h3>
                <p className="text-blue-800 leading-relaxed">
                  {post.metaDesc}
                </p>
              </div>
            )}
            {post.keywords && (
              <div>
                <h3 className="text-sm font-semibold text-blue-900 mb-2 uppercase tracking-wide">Key Topics</h3>
                <p className="text-blue-800">
                  {post.keywords}
                </p>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Call to Action */}
      <div className="mt-12 pt-8 border-t border-gray-200 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-8 text-center">
        <h3 className="text-2xl font-bold text-gray-900 mb-3">Need Legal Assistance?</h3>
        <p className="text-gray-600 mb-6">Contact our experienced team for a consultation.</p>
        <a
          href="/contact"
          className="inline-block bg-blue-600 text-white px-8 py-3 rounded-lg hover:bg-blue-700 font-semibold transition"
        >
          Schedule a Consultation
        </a>
      </div>
    </article>
  );
};

export default BlogPostDetail;
